<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"><span class="bold">quiz</span>actually</a></h1><a id="page_iii">
<p class="subtitle">The Festive Family Film Trivia Book</p>
<p class="author">Joe Shooman</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?16ec580f